import { Injectable } from '@angular/core';
import { IGeography, ICountry, IPermitType } from '@shared/interfaces';
import { Observable } from 'rxjs';
import { Http } from '@core/http/http';
import { environment } from '@app/environment';
import { map } from 'rxjs/operators';
import { Cacheable } from '@shared/models/cacheable';
import { ICrop } from '@shared/interfaces/crop';

@Injectable({
    providedIn: 'root'
})
export class DropDownsService {
    public PermitCountries: Cacheable<ICountry[]> = new Cacheable<ICountry[]>();
    public PermitCrops: Cacheable<ICrop[]> = new Cacheable<ICrop[]>();
    public PermitTypes: Cacheable<IPermitType[]> = new Cacheable<IPermitType[]>();

    constructor(private http: Http) {
        this.PermitCountries.getHandler = () => {
            return this.GetCountries();
        }

        this.PermitCrops.getHandler = () => {
            return this.GetCrops();
        }

        this.PermitTypes.getHandler = () => {
            return this.GetPermitTypes();
        }
    }    

    private GetCountries(): Observable<ICountry[]> {
        return this.http
            .get(`${environment.apiRoot}api/v1/Helper/GetCountries`)
            .pipe(map((value: IGeography[], idx: number) => {
                const result: ICountry[] = [];

                value.forEach((g: IGeography) => {
                    let iso = '??';
                    let name = g.ParentAoiName;
                    const aoiId = g.ParentAoiId;

                    if (g.ParentAoiName.charAt(2) === '-') {
                        iso = g.ParentAoiName.substring(0, 2);
                        name = g.ParentAoiName.substring(3);
                    }
                    else if (g.ParentAoiName.startsWith('US')) {
                        iso = 'US';
                    }

                    result.push({
                        AoiId: aoiId,
                        FullName: g.ParentAoiName,
                        Iso: iso,
                        Name: name
                    });
                });

                return result;
            }));
    }

    private GetCrops(): Observable<ICrop[]> {
        return this.http
            .get(`${environment.apiRoot}api/v1/Helper/GetPermitCrops`);
    }

    private GetPermitTypes(): Observable<IPermitType[]> {
        return this.http
            .get(`${environment.apiRoot}api/v1/Helper/GetPermitTypes`);
    }
}
